import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chevron-right-icon',
  templateUrl: 'chevron-right-icon.component.html'
})
export class ChevronRightIconComponent {
  constructor() {}
}
